module.exports = __webpack_public_path__ + "2f912828e7b7866871d64451801decd3.fbx";